<template>
  <div>
    <div class="bgray-800 py-5">
      <b-container>
        <b-row>
          <b-col cols="12">
            <div class="pb-2 d-sm-flex align-items-center">
              <a href="https://qesg.co.kr/" target="_blank">
                <b-img
                  class="qesg-logo"
                  src="/static_img/logos/QuantifiedESG_Logo_v3_vertical mixed.png"
                />
              </a>

              <a href="https://www.globalreporting.org/" target="_blank">
                <b-img
                  class="qesg-logo"
                  src="/static_img/logos/GRI-LicensingMarks-ContentPermission2026-mark.png"
                />
              </a>

              <a href="https://sasb.ifrs.org/" target="_blank">
                <b-img class="qesg-logo" src="/static_img/logos/SASB-Inside-Interim-Vert.png" />
              </a>

              <a
                href="https://www.ifrs.org/groups/international-sustainability-standards-board/#about"
                target="_blank"
              >
                <b-img class="qesg-logo" src="/static_img/logos/ISSB_Standards_INSIDE.png" />
              </a>
            </div>
          </b-col>
        </b-row>

        <hr class="border-white" />

        <b-row>
          <b-col cols="12">
            <p class="fw-300 f-85 gray-100">
              <span class="pr-md-3 fw-400">(주)퀀티파이드이에스지</span>
              문의. info@qesg.co.kr
            </p>
            <p class="fw-300 f-85 gray-100">
              대표. 배익현 | 사업자등록번호. 349-86-01679 | 통신판매업번호. 2022-서울종로-0575
              <br />
              문의. 02-6956-2410 (평일 09:00~17:00, 주말공휴일 휴무) <br />
              주소. 서울특별시 종로구 새문안로3길 12 (신문로1가, 신문로빌딩), 3층 퀀티파이드이에스지
              <br />
            </p>
            <p class="fw-300 f-85 gray-100 mb-0">
              Copyright 2026 QuantifiedESG, Inc. | All Rights Reserved
            </p>
          </b-col>
        </b-row>

        <hr class="border-white" />

        <b-row>
          <b-col
            cols="12"
            class="d-flex flex-column flex-lg-row justify-content-start align-items-start align-items-lg-center"
          >
            <b-button
              variant="icon-light"
              class="f-85 gray-100 mr-1 border-0"
              href="https://qesg.co.kr"
              target="_blank"
            >
              QESG 홈페이지
              <i class="fas fa-external-link-square-alt ml-1 f-90"></i>
            </b-button>
            <b-dropdown variant="icon-light" size="sm" class="mr-lg-1 border-0">
              <template #button-content>
                <span class="gray-100 mr-1 border-0 f-85 ml-1 ml-sm-0"> QESG 서비스 바로가기 </span>
              </template>
              <template>
                <b-dropdown-item class="f-85" target="_blank" href="https://assessment.qesg.co.kr">
                  ESG 평가 서비스 <b>QESG Assessment</b>
                  <i class="fas fa-external-link-square-alt ml-1 f-90"></i>
                </b-dropdown-item>
              </template>
            </b-dropdown>

            <b-button
              variant="icon-light"
              class="f-85 gray-100 border-0 mr-lg-1"
              @click="openPrivacyPolicy"
            >
              개인정보 처리방침
            </b-button>
            <b-button
              variant="icon-light"
              class="f-85 gray-100 border-0 mr-lg-1"
              @click="openTermsOfUse"
            >
              이용약관
            </b-button>
            <b-button
              variant="icon-light"
              class="f-85 gray-100 border-0 mr-lg-1"
              href="https://quantifiedesg-inc.gitbook.io/esg-reporting-tool"
              target="_blank"
            >
              사용 가이드
              <i class="fas fa-external-link-square-alt ml-1 f-90"></i>
            </b-button>
            <b-button
              v-b-modal.gri-sw-disclaimer-modal
              variant="icon-light"
              class="f-85 border-0 gray-100"
            >
              GRI Software Disclaimer
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-modal
      id="gri-sw-disclaimer-modal"
      title="GRI Software Disclaimer"
      centered
      size="lg"
      hide-footer
    >
      <p>
        본 소프트웨어에 포함된 GRI 표준은 (주)퀀티파이드이에스지가 GRI로부터 허가를 받아 사용
        중입니다.
      </p>
      <p>
        GRI는 GRI 표준의 저작권 소유자로서 (주)퀀티파이드이에스지의 승인 받은 제품 내에서 GRI 표준이
        정확하고 정확하게 표현되었음을 검증하고 승인했습니다.
      </p>
      <p>
        이 확인은 라이선스 콘텐츠의 무결성, 신뢰성 및 정확성을 유지하기 위한 것으로 한정되었습니다.
        따라서 GRI는 (주)퀀티파이드이에스지의 승인 받은 제품 또는 해당 제품에서 파생된 어떠한 제품에
        대한 정확성, 준수, 신뢰성, 목적에의 적합성 또는 품질에 대한 묵시적 또는 실질적인 표현이나
        보증을 제공하지 않으며, GRI 표준 저작권 콘텐츠의 사용에 대한 라이선스 사용에 대해
        묵시적이거나 명시적인 표현을 일체 부인합니다.
      </p>
      <p>
        라이선싱 기업이 생성한 보고서가 승인된 GRI 표준 보고서의 기준을 충족한다는 묵시적이거나
        명시적인 표현을 일체 부인합니다.
      </p>
    </b-modal>
  </div>
</template>

<script>
import { legalLinksMixin } from '@/mixins/legalLinksMixin';

export default {
  name: 'Footer',
  mixins: [legalLinksMixin]
};
</script>

<style></style>
